import dayjs from "dayjs";
import { date, number, object, string } from "yup";

export const DEFAULT_VALUES = {
  buyer: null,
  seller: null,
  sellerableType: null,
  purchaseOrder: null,
  transactionDate: dayjs(),
  amount: null,
  paymentTerm: null,
  note: "",
};

export const VALIDATION_SCHEMA = object().shape({
  buyer: object().nullable().required("Harus diisi"),
  seller: object().nullable().required("Harus diisi"),
  purchaseOrder: object().nullable().required("Harus diisi"),
  transactionDate: date().nullable().required("Harus diisi"),
  amount: number()
    .nullable()
    .typeError("Harus diisi")
    .positive("Harus lebih dari 0")
    .required("Harus diisi")
    .test(
      "max-available-down-payment",
      "Tidak boleh melebihi Sisa Uang Muka Tersedia",
      function (value) {
        const availableAmount =
          this.parent.purchaseOrder?.availableDownPaymentAmount;
        if (availableAmount == null) return true;
        return value <= availableAmount;
      },
    ),
  paymentTerm: object().nullable().required("Harus diisi"),
  note: string().nullable(),
});
